import { render, staticRenderFns } from "./PartnerParamCreate.vue?vue&type=template&id=35fde58e&scoped=true"
import script from "./PartnerParamCreate.vue?vue&type=script&lang=js"
export * from "./PartnerParamCreate.vue?vue&type=script&lang=js"
import style0 from "./PartnerParamCreate.vue?vue&type=style&index=0&id=35fde58e&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fde58e",
  null
  
)

export default component.exports